<template>
    <div id="login">
        <video id="v2" autoplay loop muted height="800rem" width="800rem">
            <source src="../../src/assets/mp4/e博视动画3秒循环.mp4" type="video/mp4" />
        </video>
        <div class="login-d">
            <div class="video-login">
                <div id="v1"></div>

                <div id="login-item">
                    <div id="login-web">
                        <h1 id="login-logo"><img src="../assets/img/logo.png" alt="" /></h1>
                        <div id="login-text">
                            <span class="text">数</span>
                            <span></span>
                            <span>字</span>
                            <span></span>
                            <span>孪</span>
                            <span></span>
                            <span>生</span>
                            <span></span>
                            <span>能</span>
                            <span></span>
                            <span>源</span>
                            <span></span>
                            <span>互</span>
                            <span></span>
                            <span>联</span>
                            <span></span>
                            <span>网</span>
                            <span></span>
                            <span>平</span>
                            <span></span>
                            <span>台</span>
                        </div>
                    </div>
                    <div id="kong"></div>
                    <div id="login-user">
                        <div class="kong1"></div>
                        <div class="clay">
                            <div class="user-p">
                                <span>欢</span><span>迎</span><span>使</span><span>用</span><span>e</span><span>博</span>视,<span>让</span><span>能</span><span>源</span><span>管</span><span>理</span><span>更</span><span>科</span><span>学</span>
                            </div>
                            <div class="kong2"></div>
                            <div class="IfClickLogin">
                                <el-tabs tab-position="top" v-model="ruleForm.radio1" @tab-click="handleClick">
                                    <el-tab-pane label="普通用户" name="1"> </el-tab-pane>
                                    <el-tab-pane label="企业管理用户" name="2"> </el-tab-pane>
                                </el-tabs>
                            </div>
                        </div>
                        <div class="kong3"></div>
                        <div class="inpBox">
                            <el-form @submit.native.prevent :model="ruleForm" :rules="rules" ref="ruleForm"
                                label-width="auto" class="demo-ruleForm">
                                <el-form-item label="账号" prop="user">
                                    <el-input onkeyup="value=value.replace(/[^\d]/g,'')" id="inp" type="tel"
                                        v-model.number="ruleForm.user" autocomplete="off"
                                        @keyup.enter.native="bigChar($event)"></el-input>
                                </el-form-item>
                                <div class="kong4"></div>
                                <el-form-item label="密码" prop="pass">
                                    <el-input id="inp2" type="password" v-model.trim="ruleForm.pass" autocomplete="off"
                                        @keyup.enter.native="bigChar($event)"></el-input>
                                    <div class="bigbox" v-show="bigChar1">
                                        <i class="bigchar">大写锁已打开</i>
                                    </div>
                                </el-form-item>
                                <div class="to-password">
                                    <router-link class="password" to="/forgetlogin" style="text-decoration: none">忘记密码
                                    </router-link>
                                </div>
                                <div class="kong5"></div>
                                <el-form-item class="btn">
                                    <el-button class="btn" type="primary" @click="submitForm('ruleForm')"
                                        @keyup.enter.native="bigChar($event)">登录
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="login-mvker">
                <div class="mvker-item">
                    <p class="mvker-text">武汉魅客科技有限公司</p>
                    <h4 class="mvker-logo">
                        <img src="../assets/img/text.png" alt="" />
                    </h4>
                </div>
                <div class="copyright">版权 © 2021武汉魅客科技出品  <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">鄂ICP备17022551号-2</a></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        play
    } from "../api/login";
    // import { passwordMd5 } from '../util/md5.js'
    export default {
        name: "Login",
        data() {
            var validateUser = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("账号是必填项"));
                    document.querySelector("#inp").style.borderBottom = "1px solid red";
                } else {
                    if (this.ruleForm.checkUser !== "") {
                        this.$refs.ruleForm.validateField("checkUser");
                        document.querySelector("#inp").style.borderBottom =
                            "1px solid gainsboro";
                    }
                    callback();
                }
            };
            var validatePass = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("密码是必填项"));
                    document.querySelector("#inp2").style.borderBottom = "1px solid red";
                } else {
                    if (this.ruleForm.checkPass !== "") {
                        this.$refs.ruleForm.validateField("checkPass");
                        document.querySelector("#inp2").style.borderBottom =
                            "1px solid gainsboro";
                    }
                    callback();
                }
            };
            return {
                handkeyCode: {},
                bigChar1: false,
                id: 2,
                seat: [],
                ruleForm: {
                    user: "",
                    pass: "",
                    radio1: "1",
                },
                rules: {
                    user: [{
                        validator: validateUser,
                        trigger: "blur"
                    }],
                    pass: [{
                            validator: validatePass,
                            trigger: "blur"
                        },
                        {
                            message: "请输入数字加字母长度5-10位",
                        },
                    ],
                },
            };
        },

        watch: {

            "this.ruleForm.user": (curVal) => {
                if (!curVal) {
                    this.ruleForm.user = "";
                    return false;
                }
                // 实时把非数字的输入过滤掉
                this.ruleForm.user = curVal.match(/\d/gi) ?
                    curVal.match(/\d/gi).join("") :
                    "";
            },
        },
        mounted() {
            //清除所有MQTT的缓存
            this.$store.state.mqtt.all = {};
            this.$store.commit("setToken", null);
            this.$store.commit(
                "setProjectInfo",
                "我是空的"
            );
            sessionStorage.setItem("NavformDataId", null)

            if (this.$store.state.homeitem.IformId) {
                this.$store.commit("NavformDataId", null);
            }
            // console.log(this.getUrlKey("n"));
            if (this.getUrlKey("n") != null) {
                //从管理后台进入
                this.ruleForm.user = this.getUrlKey("n");
                this.ruleForm.pass = this.getUrlKey("p");
                this.submitForm('ruleForm');
            }
            this.bigChar('ruleForm');
        },

        methods: {
            bigChar() {
                let _this = this;
                document.onkeydown = function (e) {
                    if (e.keyCode == 13) {
                        _this.submitForm('ruleForm');
                    }
                    if (e.keyCode == 20) {
                        if (_this.bigChar1 == true) {
                            _this.bigChar1 = false;
                        } else {
                            _this.bigChar1 = true;
                        }
                    }
                };
            },
            getUrlKey(name) {
                return (
                    decodeURIComponent(
                        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                            location.href
                        ) || [, ""])[1].replace(/\+/g, "%20")
                    ) || null
                );
            },
            handleClick(tab, event) {
                console.log(event);
            },

            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.ruleForm.radio1 == "1") {
                            // let pass=passwordMd5(this.ruleForm.pass)
                            let pass = this.ruleForm.pass;

                            play.login(this.ruleForm.user, pass).then((res) => {
                                if (res.data.status) {
                                    debugger
                                    let token = res.data.data.token;
                                    this.$store.commit("setToken", token);
                                    window.sessionStorage.setItem('token', token)
                                    // 刷新 token
                                    setInterval(() => {
                                        play.freshToken().then((res) => {
                                            this.$store.commit("setToken", res.data.data
                                                .token);
                                        });
                                    }, 45 * 60 * 1000);
                                    this.$store.commit("setUser", res.data.data.user);
                                    this.$store.commit("setProjectId", res.data.data.user.firmId);
                                    Promise.all([play.firmInfo(), play.currentProjectInfo()]).then(
                                        (res) => {

                                            this.$store.commit("setFirmInfo", res[0].data.data
                                                .firm);
                                            this.$store.commit(
                                                "setProjectInfo",
                                                res[1].data.data.project
                                            );
                                            this.$router.push("SubstationManagement");
                                        }
                                    );
                                    
                                    //判断前后台数据
                                    this.$store.commit("ForegroundRadio", this.ruleForm.radio1);
                                    this.$store.commit("webId", null);
                                    this.$store.commit("NavformDataId", 1);
                                    sessionStorage.setItem("NavformDataId", 1)
                                    // console.log(res.data.data.user.firmId);
                                    this.$store.commit("GetEchart", res.data.data.user.firmId);
                                    this.$store.commit("setData", 0);
                                    window.localStorage.setItem(
                                        "userId",
                                        res.data.data.user.firmId
                                    );
                                    if(window.location.hostname!='localhost'&&res.data.data.user.firmId=='1'){
                                        window.location.href= window.location.origin+"/proxy/ebs-ch/#/login?n="+this.ruleForm.user+"&p="+pass
                                        // window.location.href= "https://www.energydt.cn/proxy/ebs-ch/#/login?n="+this.ruleForm.user+"&p="+pass
                                    }
                                } else {

                                    this.$message({
                                        customClass: "maessage",
                                        showClose: true,
                                        message: res.data.errMsg,
                                        type: "error",
                                    });
                                }
                            });
                        } else {
                            //MD5加密
                            // let pass=passwordMd5(this.ruleForm.pass)
                            let pass = this.ruleForm.pass;
                            play.Homelogin(this.ruleForm.user, pass).then((res) => {
                                if (res.data.status) {
                                    let token = res.data.data.token;
                                    window.sessionStorage.setItem('token', token)
                                    this.$store.commit("setToken", token);
                                    this.$store.commit("setUser", res.data.data.user);
                                    this.$store.commit("ForegroundRadio", this.ruleForm.radio1);
                                    this.$store.commit("setProjectId", res.data.data.user.firmId);
                                    // 刷新 token
                                    setInterval(() => {
                                        play.freshToken().then((res) => {
                                            this.$store.commit("setToken", res.data.data
                                                .token);
                                        });
                                    }, 45 * 60 * 1000);
                                    Promise.all([play.firmInfo(), play.currentProjectInfo()]).then(
                                        (res) => {
                                            this.$store.commit("setFirmInfo", res[0].data.data
                                                .firm);
                                            this.$store.commit(
                                                "setProjectInfo",
                                                res[1].data.data.project
                                            );


                                            this.$router.push("admin");
                                        }
                                    );
                                    this.$store.commit("NavformDataId", 2);
                                    sessionStorage.setItem("NavformDataId", 2)
                                } else {
                                    // if (res.data.errMsg == "非企业用户无法登录") {
                                    //     this.$message({
                                    //         customClass: "maessage",
                                    //         showClose: true,
                                    //         message: res.data.errMsg,
                                    //         type: "error",
                                    //     });
                                    // } else {
                                    //     this.$message({
                                    //         customClass: "maessage",
                                    //         showClose: true,
                                    //         message:res.data.errMsg,
                                    //         type: "error",
                                    //     });
                                    // }
                                    this.$message({
                                            customClass: "maessage",
                                            showClose: true,
                                            message:res.data.errMsg,
                                            type: "error",
                                        });
                                }
                            });
                        }
                    } else {
                        return false;
                    }
                });
            },
        },
    };
</script>

<style scoped lang="less">
    #login {
        width: 100%;
        height: 100%;
        // background-image: url(../assets/img/loginBJ1.png);
        //如果缩小之后出现滚动条，注释下面两行代码
        min-width: 900px;
        min-height: 600px;

        video {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        video:focus {
            outline: none;
        }

        #v1 {
            margin-top: 8%;
            .w(800);
            .h(800);
            z-index: 0;
        }

        #v2 {
            margin-top: 6%;
            position: absolute;
            .w(800);
            .h(800);
            z-index: 0;
            left: 10%;
        }

        .login-d {
            width: 100%;
            height: 100%;

            background: url(../assets/img/loginBJ1.png);
            //  background-color: #ffffff;
            background-size: 100% 100%;
            position: fixed;
            z-index: 9;
            padding: 0 14% 0 10%;

            #login-web {
                .w(290);
                margin: auto;
                margin-top: 22%;

                #login-logo {
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                #login-text {
                    .w(286);
                    display: flex;
                    justify-content: space-between;
                    color: #0d94ff;

                    span {
                        font-size: 20rem;
                    }
                }
            }

            .video-login {
                display: flex;
                justify-content: space-between;
                z-index: 1;
                // padding-left: 200rem;
            }
        }

        #kong {
            .h(81);
        }

        .kong1 {
            .h(71);
        }

        .kong2 {
            .h(58);
        }

        .kong3 {
            .h(40);
        }

        .kong4 {
            .h(24);
        }

        .kong5 {
            .h(47);
        }

        #login-user {
            position: relative;
            .w(600);
            height: 52.8vh;
            box-shadow: 0px 0px 40px 0px rgba(0, 43, 102, 0.16);
            border-radius: 12px;

            flex-wrap: wrap;
            // margin-bottom: 128rem;
            background-color: #ffffff;
            //  display: -moz-box; /* 兼容Firefox */
            // display: -webkit-box
        }

        .user-p {
            padding: 0 86rem;
            font-size: 27rem;
            letter-spacing: 12rem;
            text-align: center;
            letter-spacing: 4rem;
            white-space: nowrap;
        }

        .IfClickLogin {
            font-size: 40rem !important;
            display: flex;
            justify-content: center;
        }

        .to-password {
            // height: 18px;
            white-space: normal nowrap;
            position: relative;

            // top: -20%;
        }

        .password {
            font-size: 18rem;
            color: #999999;
            position: absolute;
            right: 0;
            top: -12px;
            z-index: 9999;
        }

        .login-mvker {
            line-height: 40px;
            margin-top: 2%;

            .mvker-item {
                width: 300px;
                margin: auto;
                display: flex;
                justify-content: space-around;

                .mvker-text {
                    white-space: nowrap;
                    font-size: 16px;
                    text-align: center;
                    color: #999999;
                    // margin-bottom: 3%;
                }

                .mvker-logo {
                    width: 75px;
                    height: 15px;
                    text-align: right;

                    img {
                        // width: 75px;
                        height: 15px;
                    }
                }
            }

            .copyright {
                // .w(230);
                margin: auto;
                font-size: 16px;
                text-align: center;
                color: #999999;
                a{
                    color: #999999;
                    text-decoration: none;
                }
                a:hover{
                    color: #0d94ff;
                }
            }
        }
    }

    .bigbox {
        position: absolute;
        display: flex;
        border: 1px solid rgb(204, 204, 204);
        background: rgb(255, 255, 255);
        padding: 3px 6px;
        border-radius: 5px;
        z-index: 9999;
        right: 0;
        top: 0;
        color: rgb(128, 123, 123);
    }
</style>